import React, { useState } from 'react';

import { ProjectViewModel } from 'src/config/configs';

import { StudentViewMode } from '../../../../../config/constants';
import { ToggleLeftSideMenuAction } from '../../../../actions/menuActions';
import { ConfigurationButton } from '../../../../components/menu/atoms/ConfigurationButton';
import { SettingsMenuWrapper } from '../../../../components/menu/SettingsMenuWrapper';
import { SideMenuCondition } from '../../../../store/reducers/studentSideMenuReducer';
import { createGetResourcesFolderItemSelector } from '../../../../store/selectors/getResourcesFolderItem';
import { useStudentSelector } from '../../../../store/selectors/useStudentSelector';
import { SettingsMenu } from '../../containers/student/SettingsMenu';
import { MenuPanel } from '../MenuPanel';
import { MenuToggleButton } from '../MenuToggleButton';
import { StudentNavigationMenu } from './StudentNavigationMenu';
import { useDispatch } from 'react-redux';

enum MainMenuMode {
  Navigation = 'navigation',
  Configuration = 'configuration',
}

type StudentMainMenuProps = {
  backendUrl: string;
  projectViewModel: ProjectViewModel;
  isInPreview: boolean;
  hideStudentHeader: boolean;
  viewMode: StudentViewMode;
  onShowHomeOverview?: () => void;
};

export const StudentMainMenu = (props: StudentMainMenuProps) => {
  const dispatch = useDispatch();
  const toggleLeftSideMenu = () => dispatch(ToggleLeftSideMenuAction);

  const sideMenuCondition = useStudentSelector((state) => state.sideMenu.sideMenuCondition);
  const rootMenuItems = useStudentSelector((state) => state.rootItems);
  const resourceItem = useStudentSelector(createGetResourcesFolderItemSelector);
  const [mode, setMode] = useState<MainMenuMode>(MainMenuMode.Navigation);
  const goToNavigation = () => {
    setMode(MainMenuMode.Navigation);
  };

  const hasNoMenuItems = rootMenuItems.size === 0 && (resourceItem === undefined || resourceItem.resources.size === 0);
  if (hasNoMenuItems) {
    return null;
  }

  const studentSettingsConfigurationEnabled =
    (props.viewMode === StudentViewMode.Basic ||
      props.viewMode === StudentViewMode.Offline ||
      props.viewMode === StudentViewMode.Preview) &&
    !props.projectViewModel.additionalSettings.isCompletionTrackingEnabled;

  const goToConfiguration = studentSettingsConfigurationEnabled ? () => setMode(MainMenuMode.Configuration) : undefined;

  return (
    <>
      <MenuPanel sideMenuCondition={sideMenuCondition}>
        <MenuToggleButton onClick={toggleLeftSideMenu} hidden={sideMenuCondition !== SideMenuCondition.expanded} />
        <StudentNavigationMenu
          projectViewModel={props.projectViewModel}
          backendUrl={props.backendUrl}
          hideStudentHeader={props.hideStudentHeader}
          configurationButton={goToConfiguration ? <ConfigurationButton onClick={goToConfiguration} /> : undefined}
          isInPreview={props.isInPreview}
          viewMode={props.viewMode}
          onShowHomeOverview={props.onShowHomeOverview}
        />
      </MenuPanel>
      <SettingsMenuWrapper onBack={goToNavigation} hidden={mode !== MainMenuMode.Configuration}>
        <SettingsMenu onResetProgress={goToNavigation} />
      </SettingsMenuWrapper>
    </>
  );
};
